var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.25C5.08125 1.25 3.125 3.20625 3.125 5.625C3.125 8.90625 7.5 13.75 7.5 13.75C7.5 13.75 11.875 8.90625 11.875 5.625C11.875 3.20625 9.91875 1.25 7.5 1.25ZM4.37507 5.62497C4.37507 3.89997 5.77506 2.49997 7.50006 2.49997C9.22506 2.49997 10.6251 3.89997 10.6251 5.62497C10.6251 7.42497 8.82506 10.1187 7.50006 11.8C6.20006 10.1312 4.37507 7.40622 4.37507 5.62497ZM5.9375 5.625C5.9375 4.76206 6.63706 4.0625 7.5 4.0625C8.05823 4.0625 8.57405 4.36031 8.85317 4.84375C9.13228 5.32719 9.13228 5.92281 8.85317 6.40625C8.57405 6.88969 8.05823 7.1875 7.5 7.1875C6.63706 7.1875 5.9375 6.48794 5.9375 5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLocationIcon);
export default __webpack_public_path__ + "static/media/white-location-icon.1fe82975.svg";
export { ForwardRef as ReactComponent };